import { Box } from '@factorialco/deprecated-design-system'
import CheckCircleLine from '@factorialco/f0-react/icons/app/CheckCircleLine'
import ClockBack from '@factorialco/f0-react/icons/app/ClockBack'
import Spinner from '@factorialco/f0-react/icons/app/Spinner'
import {
  AvailablePayrollConceptFieldFragment,
  PayrollRunEmployeesCompensationFormFragment,
} from 'generated/resources/graphql'

import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'

import { useIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { useSyncStateTranslations } from 'modules/integrations/hooks/useSyncStateTranslations'

import { FailedLabel } from './FailedLabel'
import { SimpleLabel } from './SimpleLabel'
import { WarningLabel } from './WarningLabel'

const formatDate = (date: string) => {
  return i18nDateToString(stringToDate(date, 'backend_datetime'), 'ui_month_day_time')
}

interface SyncStateLabelProps {
  payrollRunEmployeeCompensations: Array<PayrollRunEmployeesCompensationFormFragment>
  compensationConcept: AvailablePayrollConceptFieldFragment
}

export const SyncStateLabel = ({
  payrollRunEmployeeCompensations,
  compensationConcept,
}: SyncStateLabelProps) => {
  const { syncEnabled } = useIntegrationsSyncContext()
  const translations = useSyncStateTranslations()

  const syncableState =
    payrollRunEmployeeCompensations.find(
      (node) => node?.payrollConcept?.id === compensationConcept.id
    )?.syncableState?.[0] || null

  if (!syncEnabled) return null

  const status = syncableState?.status

  const statusContentMap: Record<string, JSX.Element> = {
    failed: <FailedLabel errorMessages={syncableState?.errorMessages ?? []} />,
    invalid: <FailedLabel errorMessages={syncableState?.errorMessages ?? []} />,
    syncing: <SimpleLabel label={translations.syncing} icon={Spinner} />,
    outdated: <SimpleLabel label={translations.outdated} icon={ClockBack} />,
    synced: (
      <SimpleLabel
        label={`${translations.synced} ${formatDate(syncableState?.statusUpdatedAt)}`}
        icon={CheckCircleLine}
      />
    ),
  }

  return (
    <Box paddingTop="s8" paddingX="s12" width="full" textAlign="right">
      {(status && statusContentMap[status]) || <WarningLabel label={translations.pending} />}
    </Box>
  )
}
